import { ThemeType } from 'src/packages/theme';
import { Option } from 'src/packages/core';

export type IconToExcludeType = 'download' | 'notifications' | 'language';

interface SpotSymbol {
  symbolId: string;
  baseTokenId: string;
  baseTokenName: string;
  quoteTokenId: string;
  quoteTokenName: string;
  tokenFullName: string;
  canTrade: boolean;
  indexRecommendOrder: number;
  symbolName: string;
  price: string;
  change: number;
  iconUrl?: string;
}

interface FuturesSymbol {
  symbolId: string;
  baseTokenId: string;
  baseTokenName: string;
  quoteTokenId: string;
  quoteTokenName: string;
  tokenFullName: string;
  canTrade: boolean;
  indexRecommendOrder: number;
  firstLevelUnderlyingId: string;
  firstLevelUnderlyingName: string;
  secondLevelUnderlyingId: string;
  secondLevelUnderlyingName: string;
  symbolName: string;
  price: string;
  change: number;
  iconUrl?: string;
}

export type QuickSearchDataType = {
  spotSymbols: SpotSymbol[];
  futureSymbols: FuturesSymbol[];
  loading: boolean;
};

export interface HeaderProps {
  hideMainNav?: boolean;
  hideRightNav?: boolean;
  excludeRightIcons?: IconToExcludeType[];
  userLoading?: boolean;
  user?: HeaderUser;
  assets?: HeaderAssets;
  quickSearchData?: QuickSearchDataType;
  logoTitle?: string;
  announcements: Announcement[];
  notifications?: HeaderNotifications;
  locale: Locale;
  appTheme?: AppTheme;
  logout?: () => void;
  copyToClipboard?: (value: string) => void;
  theme?: ThemeType;
  kycAndFeaturesConfig?: KycAndFeaturesConfig;
  topNoticeBarHeight?: number;
}

export enum UserVerificationStatusEnum {
  NOT_VERIFIED = 0,
  UNDER_REVIEW = 1,
  VERIFIED = 2,
  REFUSED = 3,
}

export interface HeaderUser {
  id: string;
  email: string;
  kycStatus?: UserVerificationStatusEnum;
  isAffiliate?: boolean;
  showUserInfo?: boolean;
}

export interface HeaderAssets {
  total: string;
  unit: string;
  error?: any;
  showBalance?: boolean;
  toggleShowBalance?: () => void;
}

export interface HeaderNotifications {
  unread: number;
  data: Notification[];
}

export interface Announcement {
  title: string;
  directUrl: string;
  publishTime: string;
  detail?: string;
  isDirect?: boolean;
  sort?: number;
  content: string;
}
export interface Notification {
  id: string;
  userId: string;
  title: string;
  content: string;
  businessType: string;
  status: string;
  created: string;
  updated: string;
}

export interface Locale {
  languages: Option[];
  currencies: Option[];
  language: string;
  currency: string;
  changeSettings?: (field: string, value: any) => void;
}

export interface AppTheme {
  theme: ThemeType;
  changeTheme: () => void;
}

export interface KycAndFeaturesConfig {
  allowOnboarding?: boolean;
  allowTrading?: boolean;
  allowDeposit?: boolean;
  allowWithdrawal?: boolean;
  earnPlatformEnabled?: boolean;
  convertPlatformEnabled?: boolean;
  p2pPlatformEnabled?: boolean;
  tradeSpotPlatformEnabled?: boolean;
  tradeDerivativesPlatformEnabled?: boolean;
  enabledSymbols?: undefined | null | string[];
}
